import controller from './vd-suggestion-list.controller'
import template from './vd-suggestion-list.html'

export default {
  bindings: {
    data: '<',
    source: '<',
    allowClear: '<',
    onCreate: '&',
    onSelect: '&',
    lazyLoad: '<',
  },
  controller,
  template,
  transclude: {
    header: '?vdSuggestionListHeader',
  },
}
